const getters = {
  language: (state) => state.app.language,
  businessName: (state) => state.user.businessName,
  username: (state) => state.user.username,
  role: (state) => state.user.role,
};

export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js